<template lang="pug">
iframe(width='1', height='1', scrolling="no", :src="`https://springmedia.go2cloud.org/aff_l?offer_id=3876&adv_sub=${uuid}&amount=${amountBR}`")
</template>

<script>

export default {
  name: 'YboxIframe',
  props: ['amount', 'uuid'],
  computed: {
    amountBR () {
      let formatted = parseFloat(this.amount)
        .toFixed(2)
        .replace(/\./g, ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      return formatted
    }
  }
}
</script>
